import React from 'react';
import { Box, CardContent, Typography, Grid } from '@material-ui/core';
import clsx from 'clsx';
import { MembershipItem } from '@spike/membership-model';
import { calculateUsage } from 'utils/EnrollmentUtils';

interface MembershipItemsProps {
    items: MembershipItem[];
    classes: { [key: string]: string };
}

const MembershipItems: React.FC<MembershipItemsProps> = ({ items, classes }) => {
    return (
        <Box className={classes.cardStyle}>
            <CardContent className={clsx(classes.cardContent, classes.cardWide)}>
                <Typography
                    variant="h6"
                    className={classes.cardTitle}
                >
                    Membership Items
                </Typography>
                <Grid
                    container
                    className={classes.membershipItemsGrid}
                >
                    <Grid
                        item
                        xs={8}
                        className={classes.membershipItemsTitleLeft}
                    >
                        <Typography
                            variant="subtitle2"
                            className={classes.membershipItemsTitle}
                        >
                            Item
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={4}
                        className={classes.membershipItemsTitleRight}
                    >
                        <Typography
                            variant="subtitle2"
                            align="right"
                            className={classes.membershipItemsTitle}
                        >
                            Usage
                        </Typography>
                    </Grid>
                </Grid>
                {items.map((item, idx) => {
                    const { used, total } = calculateUsage(item);
                    return (
                        <Grid
                            container
                            key={idx}
                            alignItems="center"
                            className={classes.membershipItemsRow}
                        >
                            <Grid
                                item
                                xs={8}
                            >
                                <Typography
                                    variant="body1"
                                    className={classes.membershipItemsItemName}
                                >
                                    {item.itemName}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    className={classes.membershipItemsItemLabel}
                                >
                                    {item.itemType}
                                </Typography>
                            </Grid>
                            <Grid
                                item
                                xs={4}
                            >
                                <Box
                                    display="flex"
                                    justifyContent="flex-end"
                                >
                                    <Typography
                                        variant="body2"
                                        style={{ background: '#F4F4F4', borderRadius: 6, padding: '2px 10px' }}
                                    >
                                        {`${used}/${total}`}
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    );
                })}
            </CardContent>
        </Box>
    );
};

export default MembershipItems;
